import {
  Avatar,
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
  Grid,
  Slide,
  Switch,
  Typography,
} from "@material-ui/core";
import { Form, Formik } from "formik";

import React from "react";
import TextField from "../components/TextField";
import { Selectwrapper } from "../components/TextField";
import {
  toggle_activity,
  toggle_online_offline,
} from "../redux/General/generalActions";
import { StyledBadge, useStyles } from "../styles/mainStyles";
import {
  initialValue,
  validationSchema,
} from "../validation/ChangeActivity_validation";
const ChangeActivitiy = ({ offline }) => {
  const [open, setOpen] = React.useState(false);
  const [new_mode, set_new_mode] = React.useState(
    localStorage.offline === "true" ? false : true
  );
  const options = [
    localStorage.last_state !== "active"
      ? { title: "فعال", value: "active" }
      : { title: "مشکل فني", value: "technical problem" },
  ];
  const handleClickOpen = () => {
    setOpen(true);
  };
  const classes = useStyles();
  const handleCloseDialog = () => {
    setOpen(false);
  };
  return (
    <>
      <StyledBadge
        overlap="circular"
        variant="dot"
        onClick={handleClickOpen}
        style={{
          cursor: "pointer",
          margin: "0 8px",
        }}
        classes={{
          badge: offline === "false" ? classes.online : classes.offline,
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Avatar
          variant="circular"
          style={{}}
          className={classes.Avatar}
        ></Avatar>
      </StyledBadge>

      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        onClick={(e) => e.stopPropagation()}
      >
        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={(values, props) => {
            toggle_activity(values).then((res) => {
              if (res) {
                localStorage.last_state = values.last_state;
                props.resetForm();
                setOpen(false);
              }
            });
          }}
          validateOnMount
        >
          {(formik) => {
            return (
              <Form>
                <DialogContent>
                  <Grid item xs={12} container justifyContent="center">
                    <Grid
                      item
                      xs={12}
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="body1">تغییر وضعیت دفتر </Typography>
                      <Switch
                        color="primary"
                        checked={new_mode}
                        onChange={(e) => {
                          set_new_mode(!new_mode);

                          toggle_online_offline({
                            status: new_mode ? "offline" : "online",
                          }).then((res) => {
                            if (res) {
                              localStorage.offline === "true"
                                ? (localStorage.offline = "false")
                                : (localStorage.offline = "true");
                            }
                          });
                        }}
                      />
                    </Grid>
                    {/* ------------------------------------------------------------------------ deactive office */}
                    <Grid
                      item
                      xs={12}
                      style={{ marginTop: 30 }}
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item xs={12}>
                        <Typography variant="body1">
                          غیر فعال کردن دفتر
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container style={{ marginTop: 20 }}>
                        <Grid item xs={8} style={{ paddingLeft: 10 }}>
                          <TextField name="descr" label="دلیل" multiline />
                        </Grid>
                        <Grid item xs={4} style={{ paddingRight: 10 }}>
                          <Selectwrapper
                            name="last_state"
                            label="وضعیت"
                            options={options}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      justifyContent="flex-end"
                      style={{ marginTop: 30 }}
                    >
                      <ButtonGroup variant="text" color="primary">
                        <Button disabled={!formik.isValid} type="submit">
                          تایید
                        </Button>
                        <Button onClick={handleCloseDialog}>انصراف</Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </DialogContent>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
};

export default ChangeActivitiy;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
